import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Link from 'next/link'

import { Button } from '@saatva-bits/pattern-library.components.button'

import Undo from '@/components/Undo'
import { envs } from '@/config/globals'

import styles from './styles.module.scss'

const CartEmpty = ({ itemRemoved }) => {
    const titleClass = classNames('u-marginBottom--md', styles.mainTitle, styles.emptyTitle)

    return (
        <div id='cartEmpty'>
            <div className={styles.header}>
                <h1 className={titleClass}>
                    Your cart is empty. We can help with that!
                </h1>
                <Link href={envs.saatvaDomain}>
                    <Button className={styles.emptyButton} kind="primary" data-selector='continueShopping'>
                        Continue shopping
                    </Button>
                </Link>
                {itemRemoved &&
                    <div className={styles.emptyUndoWrapper}>
                        <Undo itemRemoved={itemRemoved} />
                    </div>
                }
            </div>
        </div>
    )
}

CartEmpty.propTypes = {
    itemRemoved: PropTypes.any
}

export default CartEmpty
